import styles from './ScopeBar.module.css';

export default function ScopeBar({
  sites = [],
  assets = [],
  siteId = '',
  assetKey = '',
  isLoading = false,
  error = null,
  onSiteChange,
  onAssetChange,
  onClear,
  onRetry
}) {
  const disabled = isLoading || Boolean(error);

  return (
    <section
      className={styles.scopeBar}
      aria-label="Current location"
      aria-busy={isLoading}
    >
      <div className={styles.controls}>
        <label className={styles.field}>
          <span>Site</span>

          <select
            value={siteId}
            disabled={disabled}
            onChange={event => onSiteChange(event.target.value)}
          >
            <option value="">All sites</option>

            {sites.map(site => (
              <option key={site.id} value={site.id}>
                {site.label}
              </option>
            ))}
          </select>
        </label>

        <label className={styles.field}>
          <span>Asset</span>

          <select
            value={assetKey}
            disabled={disabled}
            onChange={event => onAssetChange(event.target.value)}
          >
            <option value="">All assets</option>

            {assets.map(asset => (
              <option key={asset.key} value={asset.key}>
                {asset.label}
              </option>
            ))}
          </select>
        </label>

        {(siteId || assetKey) && (
          <button
            type='button'
            className={styles.action}
            onClick={onClear}
          >
            Return to fleet
          </button>
        )}
      </div>

      {isLoading && (
        <span className={styles.message} role="status">
          Loading locations...
        </span>
      )}

      {!isLoading && error && (
        <div className={styles.feedback}>
          <span className={styles.error} role="alert">
            {error}
          </span>

          <button
            type="button"
            className={styles.action}
            onClick={onRetry}
          >
            Retry
          </button>
        </div>
      )}
    </section>
  )
}